import { Select } from '../../../shared/ui/Select/ui/Select.jsx';
import { useEffect } from 'react';
import { apiRequests } from '../../../shared/api/apiRequests.js';
import { useQuery } from '@tanstack/react-query';

// Рефактор с initialValue
export const LanguageOptions = ({ onSelect, label, initialValue, notDefineInitialValue }) => {
  const { data } = useQuery({
    queryKey: ['getLanguages'],
    queryFn: () => apiRequests.languages.get(100),
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  useEffect(() => {
    if (data) {
      onSelect(initialValue || data.items[0]?.id);
    }
  }, [data]);

  return (
    <>
      {data && (
        <Select
          aria-label="languages"
          initialValue={initialValue}
          label={label || 'Язык'}
          onChange={(e) => onSelect(e.target.value)}
          options={data.items?.map((i) => ({
            label: i.title,
            value: i.id,
          }))}
        />
      )}
    </>
  );
};
